import { amsterdamDay, formatDagDatum, formatTijd } from '@/lib/format'

export type DayGroupLabel = 'Vandaag' | 'Gisteren' | 'Ouder'

function dayNumber(day: string): number {
  const [year, month, date] = day.split('-').map(Number)
  return Date.UTC(year, month - 1, date) / 86_400_000
}

/** Whole Amsterdam calendar days between a moment and now (0 = today, 1 = yesterday). */
function calendarDaysAgo(iso: string, now: Date): number {
  return dayNumber(amsterdamDay(now)) - dayNumber(amsterdamDay(new Date(iso)))
}

/** The group header a notification sits under; one calendar-day computation for header and label. */
export function dayGroupLabel(iso: string, now: Date = new Date()): DayGroupLabel {
  const days = calendarDaysAgo(iso, now)
  if (days <= 0) return 'Vandaag'
  if (days === 1) return 'Gisteren'
  return 'Ouder'
}

/**
 * The time label of a notification, consistent with its group: today "5 min geleden" /
 * "3 uur geleden", yesterday "gisteren 09:10", older "ma 12 okt".
 */
export function relativeTime(iso: string, now: Date = new Date()): string {
  const group = dayGroupLabel(iso, now)
  if (group === 'Gisteren') return `gisteren ${formatTijd(iso)}`
  if (group === 'Ouder') return formatDagDatum(iso)
  const minutes = Math.max(0, Math.floor((now.getTime() - new Date(iso).getTime()) / 60_000))
  if (minutes < 1) return 'nu'
  if (minutes < 60) return `${minutes} min geleden`
  return `${Math.floor(minutes / 60)} uur geleden`
}
